import reduceReducer from '@helpers/reduceReducers';

import reducer from './reducer';

export const snackbarReducer = reduceReducer(reducer);

export * from './action';
export * from './selector';
